import axios from "@/plugins/axios";
export default {
  computed: {
    $userId() {
      if (this.$store.state.userId) {
        return this.$store.state.userId;
      }
    },
    $isLogin() {
      if (this.$store.state.userId) {
        return !!this.$store.state.userId;
      } else {
        return false;
      }
    },
    $token() {
      return this.$store.state.access_token;
    },
    $type() {
      return this.$store.state.type;
    },
  },
  methods: {
    async $logout() {
      try {
        await axios.delete("/auth/logout");
        this.$store.dispatch("logout");
        this.$router.push("/auth/login");
      } catch (error) {}
    },
  },
};
